import React from 'react';
import moment from 'moment';
import { CalendarLayout, DropdownSelector, Spinner } from 'hyperdb-utils';
import Calendar from '../../../daily-rental/rental-ruleset/components/RentalRulesetEditor/Calendar';

const IbeCalendar = ({
  properties = [], onSelectProperty, selectedPropertyId = null, conditions = [], prices = {}, loading = false,
  selectedYear, selectedMonth, selectedDay, calendarDates, onChangeDate,
}) => {
  return (
    <div className="content-wrapper">
      <section className="content-header content-header-fixed">
        <div className="row">
          <div className="col-md-7">
            &nbsp; <h3 className="box-title">IBE calendar</h3>
          </div>
        </div>
      </section>
      <section className="content content-fixed">
        <div className="box box-body">
          <Spinner show={ loading } />
          <div className="row">
            <div className="col-md-3">
              <DropdownSelector
                name="property"
                label="Property"
                placeholder="--- Please select ---"
                value={ selectedPropertyId }
                options={ propertiesOptions(properties) }
                onChange={ onSelectProperty }
              />
            </div>
          </div>
          <br/><br/>
          {
            selectedPropertyId
              ? <CalendarLayout
                  minYear={ moment().subtract(1, 'year').format('YYYY') }
                  maxYear={ moment().add(1, 'year').format('YYYY') }
                  year={ selectedYear }
                  month={ selectedMonth }
                  day={ selectedDay }
                  calendarDates={ calendarDates }
                  onChangeDate={ onChangeDate }
                >
                  <Calendar prices={ prices } conditions={ conditions } displayAvailabilities={ false } showDecimals={ false } />
                </CalendarLayout>
              : null
          }
        </div>
      </section>
    </div>
  );
};

function propertiesOptions(properties) {
  return (properties || []).map(p => ({ name: p.name, value: p.id }));
}

export default IbeCalendar;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/IbeCalendar.jsx